export default "/assets/images/awards-img-03-sm.svg?5526c539dd54098069bf2a6a26576300";